<template>
  <v-navigation-drawer
    v-model="drawerModel"
    app
    :clipped="$vuetify.breakpoint.lgAndUp"
    :expand-on-hover="expandOnHover"
    class="modeDrawer"
    :class="$store.state.displaySettings.darkMode ? 'darkDrawer' : 'lightDrawer'"
  >
    <!--<v-list-item
      link
      two-line
      @click="goToSelection"
    >
      <v-list-item-action>
        <v-icon size="20px">
          mdi-arrow-left
        </v-icon>
      </v-list-item-action>

      <v-list-item-content>
        <v-list-item-title>
          Home
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>-->

    <v-divider />

    <v-list shaped>
      <template v-for="(item, key) in menus">
        <v-list-group
          v-if="item.children"
          :key="key"
          v-model="item.model"
          :color="$vuetify.theme.dark ? 'grey lighten-4' : 'grey darken-4'"
        >
          <v-icon
            slot="prependIcon"
            size="20px"
            :style="{ opacity: item.disabled ? '0.5' : null }"
          >
            {{ item.icon }}
          </v-icon>
          <template #activator>
            <v-list-item-content :disabled="item.disabled">
              <v-list-item-title>
                {{ item.text }}
              </v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item
            v-for="(child, i) in item.children"
            :key="i"
            :to="child.to"
            link
            exact
          >
            <v-list-item-action v-if="child.icon">
              <v-icon
                size="20px"
                :style="{ opacity: child.disabled ? '0.5' : null }"
              >
                {{ child.icon }}
              </v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                {{ child.text }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>

        <v-list-item
          v-else-if="item.direct"
          :key="key"
          link
          :disabled="item.disabled"
          @click="sendToDirect(item.direct)"
        >
          <v-list-item-action>
            <v-icon size="20px">
              {{ item.icon }}
            </v-icon>
          </v-list-item-action>

          <v-list-item-content>
            <v-list-item-title>
              {{ item.text }}
              <span v-if="item.direct">
                <v-icon
                  class="ml-2"
                  small
                >
                  mdi-open-in-new
                </v-icon>
              </span>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item
          v-else
          :key="item.text"
          :to="item.to"
          link
          :exact="item.to.name === 'settings'"
          :disabled="item.disabled"
        >
          <!--
            :exact="item.to.name === 'hybridDashboard'"
            example: leader should be active when leader/:id
            but dashboard should not be active when oon any page
          -->
          <v-list-item-action>
            <v-icon
              size="20px"
              :style="{ opacity: item.disabled ? '0.4' : null }"
            >
              {{ item.icon }}
            </v-icon>
          </v-list-item-action>

          <v-list-item-content>
            <v-list-item-title>
              {{ item.text }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { mapMutations } from 'vuex';

export default {
  props: {
    // menus: [{ text: 'Display', icon: 'Material', to: { name: 'Router name' } }],
    menus: {
      type: Array,
      default: null,
    },
  },

  computed: {
    currentService() {
      return this.$route.params.service || '';
    },

    drawerModel: {
      get() {
        // Always display drawer when large screen
        if (this.$vuetify.breakpoint.lgAndUp) {
          return true;
        }
        return this.$store.state.displaySettings.showDrawer;
      },
      set(value) {
        if (this.$store.state.displaySettings.showDrawer === !value) {
          this.toggleShowDrawer();
        }
      },
    },

    expandOnHover: {
      get() {
        // Always show full drawer when on mobile
        if (!this.$vuetify.breakpoint.lgAndUp) {
          return false;
        }
        return this.$store.state.displaySettings.expandDrawerOnHover;
      },
      set(value) {
        if (this.$store.state.displaySettings.expandDrawerOnHover === !value) {
          this.toggleExpandDrawerOnHover();
        }
      },
    },
  },

  methods: {
    ...mapMutations('displaySettings', [
      'toggleShowDrawer',
      'toggleExpandDrawerOnHover',
    ]),

    goToSelection() {
      this.drawerModel = false;
      this.$router.push({ name: 'settings' }).catch(() => {});
    },

    sendToDirect(url) {
      window.open(`${url}`, '_blank');
    },
  },
};
</script>

<style lang="scss" scoped>
  .modeDrawer {
    &:not(.v-navigation-drawer--is-mobile) {
      &.darkDrawer {
        background: rgba(0, 0, 0, 0.35);
      }
      &.lightDrawer {
        background: rgba(255, 255, 255, 0.35);
      }
    }

    &.v-navigation-drawer--is-mobile {
      &.darkDrawer {
        background: rgba(0, 0, 0, 0.90);
      }
      &.lightDrawer {
        background: rgba(255, 255, 255, 0.90);
      }
    }
  }
</style>
